// ------------------ config (static)
/* eslint-disable-next-line no-unused-vars */
const OrderDetailsKR = (() => {
	// private var(s)
	const _orderDetails = {};

	// private method(s)
	const _constructor = () => {
		// console.log('Config is running');
	};

	_constructor();

	// output/public
	return {
		orderDetails: _orderDetails
	};
})();
